<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
		<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[1710]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="po_currency_code" :label="$t('getapi[1999]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3102]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="order_flag_name" :label="$t('getapi[3684]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[2000]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[2001]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="pur_measure" :label="$t('getapi[1166]')"></el-table-column>
			<el-table-column prop="pur_measure_actually_qty" :label="$t('getapi[2002]')" align="right">
				<template slot-scope="scope">
					{{scope.row.pur_measure_actually_qty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="createinvoiceqty" :label="$t('getapi[2003]')" align="right">
				<template slot-scope="scope">
					{{scope.row.createinvoiceqty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="releaseinvoiceqty" :label="$t('getapi[2004]')" align="right">
				<template slot-scope="scope">
					{{scope.row.releaseinvoiceqty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="nocreateqty" :label="$t('getapi[2005]')" align="right">
				<template slot-scope="scope">
					{{scope.row.nocreateqty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column prop="noinvoiceqty" :label="$t('getapi[2006]')" align="right">
				<template slot-scope="scope">
					{{scope.row.noinvoiceqty | thousandth}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
			<el-table-column prop="local_unit_price" :label="$t('getapi[2007]')" align="right">
				<template slot-scope="scope">
					{{scope.row.local_unit_price | thousandthpurprice}}
				</template>
			</el-table-column>
			<el-table-column prop="local_amount" :label="$t('getapi[2008]')" align="right">
				<template slot-scope="scope">
					{{scope.row.local_amount | thousandthpuramount}}
				</template>
			</el-table-column>
			<el-table-column prop="line_net_unitprice" :label="$t('getapi[2009]')" align="right">
				<template slot-scope="scope">
					{{scope.row.line_net_unitprice | thousandthpurprice}}
				</template>
			</el-table-column>
			<el-table-column prop="line_net_amount" :label="$t('getapi[2010]')" align="right">
				<template slot-scope="scope">
					{{scope.row.line_net_amount | thousandthpuramount}}
				</template>
			</el-table-column>
			<el-table-column prop="line_total_unitprice" :label="$t('getapi[2011]')" align="right">
				<template slot-scope="scope">
					{{scope.row.line_total_unitprice | thousandthpurprice}}
				</template>
			</el-table-column>
			<el-table-column prop="line_total_amount" :label="$t('getapi[2012]')" align="right">
				<template slot-scope="scope">
					{{scope.row.line_total_amount | thousandthpuramount}}
				</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip prop="transact_person" :label="$t('getapi[1167]')"></el-table-column>
		</el-table>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="PurNoInvoiceViewInfo" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'purnolnvoiceview',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('purnolnvoiceview'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[971]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			if (that.total > 0) {
				that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
			} else {
				that.$refs.SetBtn.SetButtonEnable('search,refresh');
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('purnolnvoiceview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'PurNoInvoiceViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Pur/Statistics/GetPurNoInvoiceList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac,
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[1998]')
			};
			that.$http.urlpost('/Pur/Statistics/GetPurNoInvoiceToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
